var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.466797,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#5952FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1998 7.4375C20.6798 7.4375 25.9187 8.51554 28.3774 10.9553C29.0015 11.5795 29.8148 12.7899 29.8148 14.5866C29.8148 17.764 27.2615 22.6247 24.4624 25.4616C23.0061 26.9179 20.6987 28.8282 17.5781 28.8282C14.5331 28.8282 12.2067 26.7477 11.5448 26.0858C8.97262 23.4947 7.11914 19.5797 7.11914 15.9105C7.11914 13.6031 7.7811 11.5795 9.44545 9.8962C10.9963 8.32641 13.6631 7.4375 17.1998 7.4375ZM21.512 20.0903C22.6846 18.9177 23.0061 17.4614 23.0061 16.6671C23.0061 16.0808 22.8548 15.2297 22.1361 14.511C21.0202 13.3951 19.8098 13.0925 18.467 13.0925C16.7837 13.0925 15.6489 13.6221 14.8924 14.3786C14.3061 14.9649 13.7954 15.8916 13.7954 17.1966C13.7954 18.5016 14.4763 19.7499 15.2328 20.5064C15.9326 21.2062 17.0107 21.7168 18.1265 21.7168C19.2424 21.7168 20.3394 21.2629 21.512 20.0903Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject01);
export default __webpack_public_path__ + "static/media/project-01.2779e7e08ffae49f93d73fd0b7c831c8.svg";
export { ForwardRef as ReactComponent };